// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"0e050cd8","801":"66a28d48"}[chunkId] + ".chunk.css";
};